import { Component, SimpleChanges } from '@angular/core';
import { RsfMainSBaseComponent } from '../rsf-main-s-base/rsf-main-s-base.component';
import { FormStatusEnum, Tag } from 'src/app/common/enumerations/enumerations';
import { RSFConfiguration } from '../../rsf.service';

@Component({
  selector: 'rsf-main-s5',
  templateUrl: './rsf-main-s5.component.html',
  styleUrls: ['./rsf-main-s5.component.scss']
})
export class RsfMainS5Component extends RsfMainSBaseComponent {
  overrideShieldingWorkCompleteDisabled = false;

  /**
   * Updates shielding verification disabled state and permits the signed Work Complete task to be
   * reopened when no shielding verification has been recorded, unless the backend locked it because of the
   * Parent/Child RSF order (advanced Parent, or Child whose Parent already signed Work Complete).
   * @param changes Angular input changes for the RSF section.
   */
  override ngOnChanges(changes: SimpleChanges): void {
    const wfSignatures = this.rsf?.wfTable?.wfTableLocal?.wfSectionLocals.flatMap(s => s.wfSignatures).filter(s => s?.sectionNumber == 5);
    const workCompleteSignature = wfSignatures?.find(s => s?.code == Tag.SHLD_WORK_COMPLETE);

    // Deactivate shielding verification signatures if the user is the submitter
    const submitterID = workCompleteSignature?.signedBy?.id;
    const shieldingVerificationSignatures = wfSignatures?.filter(s => (s?.wfTaskLocal.wfStepLocal?.wfStepStatusLocals.map(st => st?.status).some(status => status == FormStatusEnum.ShieldingInspections)));
    shieldingVerificationSignatures?.forEach(s => s!.disabled = this.currentUser?.id == submitterID);

    // The backend disables Work Complete when the Parent/Child order forbids reopening it (an advanced Parent, or a Child whose Parent signed Work Complete).
    const workCompleteLockedByRelationship = !!workCompleteSignature?.disabled;

    // Allow unapprove Shielding Work Complete if no verification has been signed, unless a Parent/Child relationship locks it.
    this.overrideShieldingWorkCompleteDisabled = !!workCompleteSignature?.signed && workCompleteSignature.signedBy?.id == this.currentUser?.id && !shieldingVerificationSignatures?.some(s => s?.signed) && !workCompleteLockedByRelationship;
  }

}
